import { format, formatISO } from 'date-fns';

export const formatUiDate = (dateString) => format(new Date(dateString), 'MM/dd/yyyy');
export const formatUiDateAndTime = (dateString) =>
  format(new Date(dateString), 'MM/dd/yyyy hh:mm aa');
export const formatUiTime = (dateString) => format(new Date(dateString), 'hh:mm aa');
export const nowISOFormat = () => formatISO(Date.now());
